import React, { useState } from 'react';
import { Card, Col, Row } from 'react-bootstrap';

import { DefaultSpinnerCenter } from '@components/Loader/Loader';
import { ProductSheetTable } from '@components/Product/ProductSheet/ProductSheetTable';
import { Page500 } from '@containers/ErrorPages';
import { productApi } from '@reducers/product/product';

const ProductSheetPDFObject = ({ location }) => {
  const [show, setShow] = useState(true);
  return (
    <>
      <div className="text-center" hidden={!show}>
        <DefaultSpinnerCenter />
      </div>
      <object
        id="pdf"
        data={location}
        type="application/pdf"
        width="100%"
        height="1000px"
        onLoad={() => setShow(false)}
        aria-label="productSheetPDF"
      />
    </>
  );
};

export const ProductSheet = () => {
  const [title, setTitle] = useState('');
  const [productLocation, setProductLocation] = useState();
  const { data, isLoading, isError } = productApi.useGetProductSheetsQuery();

  if (isLoading) {
    return <DefaultSpinnerCenter />;
  }
  if (isError) {
    return <Page500 />;
  }

  return (
    <>
      <Row className="mb-3">
        <Col md={12}>
          <Card>
            <Card.Header className="bg-didxl text-white">
              Product sheets
            </Card.Header>
            <Card.Body>
              <ProductSheetTable
                data={data}
                productLocation={productLocation}
                setTitle={setTitle}
                setProductLocation={setProductLocation}
              />
            </Card.Body>
          </Card>
        </Col>
      </Row>
      {productLocation ? (
        <Row>
          <Col md={12}>
            <Card>
              <Card.Header className="bg-didxl text-white">{title}</Card.Header>
              <Card.Body>
                <ProductSheetPDFObject location={productLocation} />
              </Card.Body>
            </Card>
          </Col>
        </Row>
      ) : null}
    </>
  );
};
